const switchBtns = document.querySelectorAll(".button-switch_btn");

function moveBackground(pos){
	let bg = document.querySelector(".button-switch--bg"); 
	let currentLeft = parseInt(bg.style.left);
	let newLeft = (100 / switchBtns.length) * pos;
	bg.style.left = newLeft+"%"; 
}

function toggleButtonActive(btn){
	switchBtns.forEach(function(btn){
		btn.classList.remove("button-switch__active");
	});
	if(btn.classList.contains("button-switch__active")){
		btn.classList.remove("button-switch__active");
	}else{
		btn.classList.add("button-switch__active");
	}
}

switchBtns.forEach(function(btn,i){
	btn.addEventListener('click', function(){
		toggleButtonActive(btn); 
		moveBackground(i);
	})
});

const lengthChart = document.querySelector(".js_nails-length-chart"); 
const shapeChart = document.querySelector(".js_nails-shape-chart"); 
const mobileShapeNails = document.querySelector(".mobile-nail-shape--container");
const mobileLengthNails = document.querySelector(".mobile-nail-length-carousel--container");

function toggleSizeAndShapeCharts(b) {
    let chart = b.getAttribute("data-chart"); 
    if (chart == "length") {
        lengthChart.classList.add("active-chart");
        shapeChart.classList.remove("active-chart");
        mobileLengthNails.classList.add("active-chart");  
        mobileShapeNails && mobileShapeNails.classList.remove("active-chart");
    } else {
        lengthChart.classList.remove("active-chart"); 
        shapeChart.classList.add("active-chart");
        mobileLengthNails.classList.remove("active-chart"); 
        mobileShapeNails && mobileShapeNails.classList.add("active-chart");
    }  
   
}

switchBtns.forEach(function(btn,i){
	btn.addEventListener('click', function(){
		toggleSizeAndShapeCharts(btn);
	})
});

document.addEventListener("DOMContentLoaded", function() {
    typeof window.nailChartBtns > "u" && (window.nailChartBtns = document.querySelectorAll(".nails-size-chart__btn")),
    typeof window.nailCharts > "u" && (window.nailCharts = document.querySelectorAll(".nails-length-chart img"));
    let linesGrid = document.querySelector(".length-messuring-lines--grid")
      , measuringLines = document.querySelectorAll(".length-measuring-line--grid")
      , classesToRemove = ["js__highlighted-length", "js__before-highlighted-length", "js__before-before-highlighted-length", "js__before-before-before-highlighted-length"];
    function removeClassFromLines(classes) {
        measuringLines.forEach(line => {
            classes.forEach(c => line.classList.remove(c))
        }
        )
    }
    function moveMeasuringLines(btn) {
        if (!btn || !linesGrid)
            return;
        let moveLineTo = btn.getAttribute("data-chart-btn");
        moveLineTo && linesGrid.setAttribute("data-using-measuring-line", moveLineTo)
    }
    function toggleChart(btn) {
        if (!btn)
            return;
        let btnLine = btn.getAttribute("data-chart-btn");
        if (!btnLine)
            return;
        removeClassFromLines(classesToRemove);
        let selectedLine = document.querySelector(`.js__${btnLine}`);
        if (!selectedLine)
            return;
        let currentLine = selectedLine;
        ["js__before-highlighted-length", "js__before-before-highlighted-length", "js__before-before-before-highlighted-length"].forEach(className => {
            currentLine.previousElementSibling && (currentLine = currentLine.previousElementSibling,
            currentLine.classList.add(className))
        }
        ),
        selectedLine.classList.add("js__highlighted-length")
    }
    function highLightButtons(btn) {
        btn && (nailChartBtns.forEach(b => {
            b.classList.remove("highlighted__btn")
        }
        ),
        btn.classList.add("highlighted__btn"))
    }
    nailChartBtns.length && nailChartBtns.forEach(function(btn) {
        btn.addEventListener("mouseenter", function() {
            toggleChart(btn),
            moveMeasuringLines(btn)
        })
    })
});
//# sourceMappingURL=/cdn/shop/t/8/assets/chart-hover-click--toggle.js.map?v=11888111152287173911754940889
